import { useRouteError } from 'react-router-dom';
import { ErrorPageUI } from './ErrorBoundary';

interface StandaloneErrorPageProps {
  title?: string;
  message?: string;
  showHomeButton?: boolean;
  showReloadButton?: boolean;
}

interface RouteError {
  status?: number;
  statusText?: string;
  message?: string;
  data?: unknown;
}

export function StandaloneErrorPage({
  title,
  message,
  showHomeButton = true,
  showReloadButton = false
}: StandaloneErrorPageProps) {
  // Get route error information from React Router
  const routeError = useRouteError() as RouteError | undefined;

  // Determine if this is a 404 error
  const is404 = routeError?.status === 404;

  return (
    <ErrorPageUI
      title={title}
      message={message}
      showHomeButton={showHomeButton}
      showReloadButton={showReloadButton}
      is404={is404}
    />
  );
}
